var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friendlyLink"},[_c('div',{staticClass:"border-bottom"},[_c('h3',[_vm._v("友情链接")]),_vm._v(" "),_c('div',{staticClass:"links"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dc8bb2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common-components/Friendlinks.vue
// module id = null
// module chunks = 